<template>
  <div class="index">
    <van-nav-bar title="病例详情" fixed left-arrow @click-left="$router.back()" style="z-index: 9999999" />
    <div class="box">
      <div class="box-title">{{ caseobj.title }}</div>
      <div class="box-time">
        <div class="box-time-name">{{ caseobj.created_at }}</div>
      </div>
      <div class="box-title" style="margin-top: 40px;">病例资料：</div>
      <div class="box-con" v-if="caseobj.case_url">
        <!-- {{ caseobj.case_url }} -->
        {{ caseobj.case_url.split("/")[caseobj.case_url.split("/").length - 1] }}
      </div>
      <div class="box-btn">
        <el-button v-if="true"
          style="width: 102px;height: 43px;font-size: 15px;border-radius: 6px;background-color: #A04BA5;border-color: #A04BA5;"
          type="primary" @click="download(caseobj.case_url)">
          下载
        </el-button>
      </div>
    </div>
  </div>
</template> 
<script>
export default {
  data() {
    return {
      caseobj: {}
    }
  },
  created() {
    this.getcaseobjApi()
  },
  methods: {
    //获取信息
    async getcaseobjApi() {
      const { data: data } = await this.$http.get(
        "medical/case", { params: { id: this.$route.query.id } }
      );
      this.caseobj = data.data
    },
    //下载
    download(url) {
      window.open(url);
    }
  }
}
</script> 
<style scoped>
.index {
  width: 100%;
  position: relative;
}

.index-head {
  width: 100%;
  /* height: 205px; */
  /* background: url(@/assets/img/home/lanse.png) no-repeat center 0px; */
  background-position: center 0px;
  background-size: cover;
}

.index-head-title {
  color: #FFFFFF;
  font-size: 30px;
  /* padding: 53px 0 0 235px; */
}

.box {
  position: relative;
  /* top: -60px; */
  /* margin: 0 235px; */
  height: 700px;
  background-color: #fff;
  border-radius: 8px;
  /* padding: 48px 62px; */
}

.box-title {
  color: #000000;
  font-size: 15px;
  margin-bottom: 24px;
  font-weight: 600;
  margin-top: 15px;
  min-height: 17px;
}

.box-time {
  display: flex;
  align-items: center;
  padding-bottom: 27px;
  border-bottom: 1px solid #F2F7FC;
  min-height: 17px;
}

.box-time-img {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}

.box-time-name {
  color: #C1C3C7;
  font-size: 14px;
  font-size: 14px;
  padding-top: 1px;
}

.box-con {
  width: 100%;
  color: #0072F5;
  font-size: 16px;
  margin-bottom: 30px;
  word-wrap: break-word;
}

.box-btn {}
</style> 